<template>
  <div>
   <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" 
   style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<g>
		<path d="M230.007,138.784V82.499c0-11.173-7.368-20.656-17.5-23.849V29.999c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5V58.65
			c-10.132,3.193-17.5,12.676-17.5,23.849v62.5c0,4.142,3.357,7.5,7.5,7.5h35c4.136,0,7.5,3.365,7.5,7.5c0,4.135-3.364,7.5-7.5,7.5
			h-68.555c-2.416-8.509-8.829-15.352-17.077-18.353c10.771-9.621,17.567-23.603,17.567-39.147v-30
			c0-16.702-7.849-31.596-20.042-41.218l1.538-2.663c2.071-3.587,0.842-8.174-2.745-10.245c-3.589-2.072-8.175-0.843-10.245,2.745
			l-1.526,2.643c-3.797-1.523-7.807-2.618-11.979-3.218v-3.044c0-4.142-3.357-7.5-7.5-7.5s-7.5,3.358-7.5,7.5v3.044
			c-4.171,0.599-8.182,1.695-11.979,3.218l-1.526-2.643c-2.072-3.588-6.659-4.817-10.245-2.745
			c-3.587,2.071-4.816,6.658-2.745,10.245l1.538,2.663c-12.193,9.622-20.042,24.516-20.042,41.218v30
			c0,15.709,6.944,29.818,17.914,39.447c-7.999,3.187-14.16,10.019-16.417,18.438C22.313,171.153,0,195.513,0,224.999
			c0,29.162,21.827,53.306,50,56.995v75.005c0,4.142,3.357,7.5,7.5,7.5H65v107.094l-24.872,8.291
			c-3.93,1.31-6.053,5.558-4.743,9.487c1.048,3.143,3.974,5.13,7.114,5.13c0.786,0,1.586-0.125,2.373-0.387l30-10
			c3.063-1.021,5.128-3.887,5.128-7.115v-112.5h45v112.5c0,3.228,2.065,6.094,5.128,7.115l30,10
			c0.787,0.262,1.587,0.387,2.373,0.387c3.141,0,6.066-1.988,7.114-5.13c1.31-3.93-0.813-8.177-4.743-9.487L140,471.593V364.499h7.5
			c4.143,0,7.5-3.358,7.5-7.5v-174.5h67.507c12.406,0,22.5-10.093,22.5-22.5C245.007,150.221,238.737,141.879,230.007,138.784z M215.007,137.499h-20v-30h20V137.499z M215.007,92.498h-20v-9.999c0-5.514,4.486-10,10-10c5.514,0,10,4.486,10,10V92.498z M50,266.823c-19.868-3.554-35-20.949-35-41.824s15.132-38.27,35-41.824V266.823z M64.442,79.999c0-20.678,16.823-37.5,37.5-37.5
			c20.678,0,37.5,16.822,37.5,37.5v2.5h-15.139c-5.653-6.325-13.747-10-22.361-10s-16.708,3.675-22.361,10H64.442V79.999z M64.442,109.999v-12.5h18.791c2.502,0,4.84-1.248,6.232-3.327c2.797-4.178,7.462-6.673,12.477-6.673s9.68,2.495,12.477,6.673 c1.393,2.079,3.73,3.327,6.232,3.327h18.791v12.5c0,20.678-16.822,37.5-37.5,37.5C81.264,147.499,64.442,130.677,64.442,109.999z M110,162.499v30H95v-30H110z M65,174.999c0-6.893,5.607-12.5,12.5-12.5H80v37.5c0,9.777-6.271,18.114-15,21.21V174.999z M139.999,349.499H65V236.744c14.672-2.99,26.255-14.573,29.245-29.245h16.509c2.99,14.672,14.573,26.255,29.245,29.245V349.499z M140,221.209c-8.729-3.096-15-11.432-15-21.21v-37.5h2.5c6.893,0,12.5,5.607,12.5,12.5V221.209z"/>
	</g>
</g>
<g>
	<g>
		<path d="M504.5,182.499c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5H502v-30h2.5c4.143,0,7.5-3.358,7.5-7.5
			c0-4.142-3.357-7.5-7.5-7.5h-85v-27.5c0-20.678-16.822-37.5-37.5-37.5h-77.5c-20.678,0-37.5,16.822-37.5,37.5v149.5h-26
			c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h26v15h-74.5c-4.143,0-7.5,3.358-7.5,7.5v205c0,4.142,3.357,7.5,7.5,7.5
			s7.5-3.358,7.5-7.5V385.817l19.451,34.838c1.325,2.373,3.831,3.844,6.549,3.844h30c2.718,0,5.224-1.471,6.549-3.844L282,385.817
			v101.182c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-205c0-4.142-3.357-7.5-7.5-7.5H282v-179.5c0-12.407,10.094-22.5,22.5-22.5
			h25c12.406,0,22.5,10.093,22.5,22.5v27.5h-32.5c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h2.5v30h-2.5
			c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h2.5v122h-2.5c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h2.5
			v30h-2.5c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5h70v15h-60c-4.143,0-7.5,3.358-7.5,7.5v99.969
			c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-62.469h52.5v32.5c0,12.407,10.094,22.5,22.5,22.5s22.5-10.093,22.5-22.5v-32.5H487
			v62.5c0,4.142,3.357,7.5,7.5,7.5s7.5-3.358,7.5-7.5v-100c0-4.142-3.357-7.5-7.5-7.5h-60v-15h70c4.143,0,7.5-3.358,7.5-7.5
			c0-4.142-3.357-7.5-7.5-7.5H502v-30h2.5c4.143,0,7.5-3.358,7.5-7.5c0-4.142-3.357-7.5-7.5-7.5H502v-122H504.5z M251.598,409.499
			h-21.195l-25.125-45h71.445L251.598,409.499z M282,349.499h-82v-60h82V349.499z M382,72.499c12.406,0,22.5,10.093,22.5,22.5v27.5
			H367v-27.5c0-8.436-2.801-16.228-7.521-22.5H382z M419.5,456.999c0,4.136-3.364,7.5-7.5,7.5s-7.5-3.364-7.5-7.5v-32.5h15V456.999z M487,394.499v15H337v-15H487z M404.5,379.499v-15h15v15H404.5z M487,349.499H337v-30h150V349.499z M487,167.499H374.5
			c-4.143,0-7.5,3.358-7.5,7.5c0,4.142,3.357,7.5,7.5,7.5H487v122H337v-122h7.5c4.143,0,7.5-3.358,7.5-7.5
			c0-4.142-3.357-7.5-7.5-7.5H337v-30h150V167.499z"/>
	</g>
</g>
<g>
	<g>
		<path d="M412,229.503c-16.542,0-30,13.458-30,30s13.458,30,30,30s30-13.458,30-30S428.542,229.503,412,229.503z M412,274.503
			c-8.271,0-15-6.729-15-15s6.729-15,15-15s15,6.729,15,15S420.271,274.503,412,274.503z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
  </div>
</template>

<script>
export default {
  name: "BeerBottlesSvg"
};
</script>

<style>
</style>